require("dotenv").config();
import ReactOld from "react";
import ReactDOMOld from "react-dom";
import ArticleListing from "./dynamic/articleList/src/lazyLoad";
import Gallery from "./dynamic/gallery/src/lazyLoad";
import LatestVideo from "./dynamic/LatestVideo/src/LatestVideo";
import LatestMediaTabs from "./dynamic/LatestMediaTabs/src";
import VideoFeed from "./dynamic/VideoFeed/src/VideoFeed";
import VideoBackground from "./dynamic/VideoBackground/src/VideoBackground";
import VideoHighlights from "./dynamic/VideoHighlights";
import FeaturedPlayerSection from "./dynamic/FeaturedPlayer/FeaturedPlayer";
import FeaturedPlayerV2 from "./dynamic/FeaturedPlayerV2";
import LatestResults from "./dynamic/LatestResults/src/LatestResults";
import DrawSheet from "./dynamic/DrawSheets/src/lazyLoad";
import OrderOfPlay from "./dynamic/OrderOfPlay/src/lazyLoad";
import WhatsOn from "./dynamic/WhatsOnHero/lazyLoad";
import Ranking from "./dynamic/RankingHero/lazyLoad";
import ShareBtn from "./dynamic/ShareButton/src";
import TopRankings from "./dynamic/TopRankings/src/TopRankings";
import CarouselLatestTournaments from "./dynamic/LatestTournamentV2";
import { PlayerProfileTourTabs } from "./dynamic/PlayerProfile/PlayerProfileTabs";
import Tabs, { Tab } from "./static/Tabs/Tabs";
import { PPOverview } from "./dynamic/PlayerProfile/lazyLoad";
import { PPActivity } from "./dynamic/PlayerProfile/lazyLoad";
import { PPRankings } from "./dynamic/PlayerProfile/lazyLoad";
import { PPPoints } from "./dynamic/PlayerProfile/lazyLoad";
import { PPTitles } from "./dynamic/PlayerProfile/lazyLoad";
import { PPSlams } from "./dynamic/PlayerProfile/lazyLoad";
import { scrollToPProfileTabs } from "./dynamic/PlayerProfile/PlayerProfileTabs";
import PlayerNav from "./dynamic/PlayerNav/PlayerNav";
import { PlayerSearch } from "./dynamic/PlayerNav/PlayerNav";
import H2HPage from "./dynamic/H2HPage/lazyLoad";
import CompanyStructureLightbox from "./static/CompanyStructureLandingPage/init";
import CommercialPartnersLightbox from "./static/CommercialPartnersLandingPage/init";
import OurDepartmentsLightbox from "./static/JoinUs/init";
import OurValues from "./static/JoinUs/OurValues";
import { ApprovedBalls } from "./dynamic/TennisTech/lazyLoad";
import { ClassifiedSurfaces } from "./dynamic/TennisTech/lazyLoad";
import { makeAccordion } from "./static/TennisTech/utils";
import { ApprovedProductsInit } from "./static/TennisTech/ApprovedProducts";
import { RRDropdown } from "./static/RulesAndRegulationsLandingPage";
import { GenericDropdown } from "./static/GenericLandingPage";
import MembersAssociation from "./dynamic/MembersAssociation/index";
import { successStoriesInit } from "./static/SuccessStories/index";
import AcceptanceList from "./dynamic/AcceptanceList/lazyLoad";
import { DrawSizeFilter } from "./dynamic/InfoTournament";
import TournamentTable from "./dynamic/TournamentCalendar";
import H2HModule from "./dynamic/H2HModule";
import WTNWidgetWrapper from "./dynamic/PlayerProfile/widgetWrapper";
import WTNWidget from "./dynamic/PlayerProfile/WTNWidget";
import { HeadlineImagesCarousel } from "./static/HomepageHeroV2/GrowingTheGame";
import HomepageHero from "./static/HomepageHeroV2";
import RankingsHome from "./dynamic/RankingsHome";
import Qualification from "./dynamic/Qualifications";
import PastChampions from "./dynamic/PastChampions/lazyLoad";
import RoundUpResultsTable from "./dynamic/RoundUpResultsTable";
import StatSummary from "./static/StatSummary";
import MostTitles from "./dynamic/MostTitles";
import PrintOrderOfPlay from "./dynamic/OrderOfPlay/src/PrintPage";
import PrintPage from "./dynamic/DrawSheets/src/PrintPage";
import LeadEditorial from "./dynamic/LeadEditorial";
import MatchesWon from "./dynamic/MatchesWon";
import GlobalSearch from "./dynamic/GlobalSearch";
import EntryList from "./dynamic/EntryList";
import LatestScores from "./dynamic/LatestScores";
import PastChampionsOlympic from "./dynamic/PastChampions/olympics";
import AdBanner from "./static/AdBanner/wrapper";
import OlympicsVideoPlayer from "./static/OlympicsVideoPlayer";
import SpecialTournamentHeading from "./static/Pages/Tournaments/Heading";
import OlympicsCTA from "./dynamic/OlympicsCTA";
import PlayerPathwayDoubleCta from "./dynamic/OlympicsCTA";
import OlympicsTournamentHeading from "./static/Pages/Tournaments/OlympicsHeading";
import News from "./dynamic/News";
import HomepageGrid from "./static/HomepageGrid";
import HomeCTA from "./dynamic/HomeCTA";
import Events from "./dynamic/Events";
import StoryTeller from "./dynamic/StoryTeller";
import MyAccount from "./dynamic/MyAccount";
import ThemeModule from "./static/Theming";
import SignupBanner from "./dynamic/SignupBanner";
import UpcomingEvents from "./dynamic/UpcomingEvents";
import InfoPane from "./dynamic/InfoPane";
import PlayerPathwayTiles from "./static/PlayerPathwayTiles";
import StatisticsBanner from "./static/StatisticBanner";
import PlayerPathwayRecipients from "./static/PlayerPathwayRecipients";
import VideoFrame from "./dynamic/VideoFrame";
import HallOfChampionsHeader from "./static/Header";
import HallOfChampions from "./static/HallOfFame";
import TimelineModule from "./static/Timeline";
import WSCBlaze from "./dynamic/WSCBlaze";

import {
  setResponsiveImage,
  resizeVideos,
  debounce,
  createLabel,
  collapseRegion
} from "./helpers";
import loadLightbox, { open } from "./static/Lightbox/src";
import "./base/src/index.ts";

// Static component css
import "./base/src/index.scss";
import "./static/Footer/src/index.scss";
import "./static/NewsletterForm/src/index.scss";
import "./static/HeroCircuit/index.scss";
import "./static/AboutSection/index.scss";
import "./static/TournamentHero/index.scss";
import "./static/PlayerHero/index.scss";
import "./static/TabsLinksTournaments/index.scss";
import "./static/ArticleNextPrev/index.scss";
import "./static/navigation/src/index.scss";
import "./static/Dropdown/index.scss";
import "./static/Lightbox/src/index.scss";
import "./dynamic/InfoTournament/index.scss";
import "./static/GenericLandingPage/index.scss";
import "./static/GenericLandingPage/tabs.scss";
import "./static/HomePageLayout/index.scss";
import "./static/CompanyStructureLandingPage/index.scss";
import "./static/CommercialPartnersLandingPage/index.scss";
import "./static/ContactUsLandingPage/index.scss";
import "./static/TennisTech/index.scss";
import "./static/RulesAndRegulationsLandingPage/index.scss";
import "./static/PublicationsLandingPage/index.scss";
import "./static/Accordion/index.scss";
import "./static/SuccessStories/index.scss";
import "./static/FAQsLandingPage/index.scss";
import "./static/JoinUs/index.scss";
import "./static/Events/index.scss";
import "./static/Pages/Players/index.scss";
import "./static/500page/index.scss";
import "./static/HomepageHeroV2/style.scss";
import "./static/AdBanner/index.scss";
import "./static/StatSummary/index.scss";
import "./static/CircuitLandingPage/quick-links.scss";
import "./static/Statistics/index.scss";
import "./static/SignUp/index.scss";
import "./static/WTTLive/index.scss";
import "./static/WTTLive/ribbon.scss";
import "./static/OrderOfPlay/index.scss";

const helpers = {
  setResponsiveImage,
  resizeVideos,
  debounce,
  createLabel,
  CompanyStructureLightbox,
  CommercialPartnersLightbox,
  OurDepartmentsLightbox,
  ApprovedProductsInit,
  makeAccordion,
  collapseRegion,
  successStoriesInit,
  scrollToPProfileTabs,
  Lightbox: {
    loadLightbox,
    open
  }
};

export {
  ReactOld,
  ReactDOMOld,
  RRDropdown,
  GenericDropdown,
  ArticleListing,
  Gallery,
  LatestVideo,
  VideoFeed,
  VideoBackground,
  VideoHighlights,
  LatestMediaTabs,
  WhatsOn,
  Ranking,
  Tabs,
  Tab,
  ShareBtn,
  helpers,
  FeaturedPlayerSection,
  FeaturedPlayerV2,
  LatestResults,
  TopRankings,
  CarouselLatestTournaments,
  DrawSheet,
  OrderOfPlay,
  PPOverview,
  PPActivity,
  PPRankings,
  PPPoints,
  PPTitles,
  PlayerProfileTourTabs,
  PlayerPathwayRecipients,
  PPSlams,
  H2HPage,
  PlayerNav,
  ApprovedBalls,
  ClassifiedSurfaces,
  MembersAssociation,
  OurValues,
  PlayerSearch,
  AcceptanceList,
  DrawSizeFilter,
  TournamentTable,
  WTNWidgetWrapper,
  HomepageHero,
  H2HModule,
  RankingsHome,
  HeadlineImagesCarousel,
  Qualification,
  PastChampions,
  RoundUpResultsTable,
  StatSummary,
  MostTitles,
  PrintOrderOfPlay,
  PrintPage,
  MatchesWon,
  LeadEditorial,
  GlobalSearch,
  EntryList,
  LatestScores,
  PastChampionsOlympic,
  AdBanner,
  WTNWidget,
  OlympicsVideoPlayer,
  SpecialTournamentHeading,
  OlympicsCTA,
  OlympicsTournamentHeading,
  News,
  HomepageGrid,
  HomeCTA,
  Events,
  StoryTeller,
  MyAccount,
  ThemeModule,
  SignupBanner,
  UpcomingEvents,
  InfoPane,
  PlayerPathwayTiles,
  StatisticsBanner,
  PlayerPathwayDoubleCta,
  TimelineModule,
  VideoFrame,
  HallOfChampions,
  HallOfChampionsHeader,
  WSCBlaze
};
